import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { BrowserRouter, Routes, Route } from "react-router";
import { HelmetProvider } from 'react-helmet-next';
import Home from './pages/Home'
import Work from './pages/Work'
import Project from './pages/Project'
import OurProcess from './pages/OurProcess'
import About from './pages/About'
import Contact from './pages/Contact'
import PrivacyPolicy from './pages/PrivacyPolicy'
import FourOhFour from './pages/FourOhFour'
import Navbar from './components/Navbar'
import Footer from './components/Footer'

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App">
          <a href="#main-content" className="skip-link">Skip to main content</a>
          <Navbar />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-process" element={<OurProcess />} />
            <Route path="/work" element={<Work />} />
            <Route path="/project/:id" element={<Project />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/*" element={<FourOhFour />} />
          </Routes>
        
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
